import { FileSetAsTemplateEvent } from '@rematter/frontend-lib-api-client/grpc/files/v1/file_events_pb';
import { Col, humanReadableDateTime } from '@rematter/ui-web';
import { FieldDisplay, IDField } from '@rematter/ui-web';

import { protoTimestampToZonedDateTimeString } from '@/audit-log/_components/_shared';
import { getLocale } from '~/shared/utils/locale';

type FileSetAsTemplateDetailProps = {
  event: FileSetAsTemplateEvent;
};

const formatFileSize = (size: bigint): string => {
  const bytes = Number(size);
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};

export const FileSetAsTemplateDetail = ({
  event,
}: FileSetAsTemplateDetailProps) => {
  const file = event.file;
  const setAtStr = protoTimestampToZonedDateTimeString(event.setAt);

  if (!file) {
    return (
      <Col className="@FileSetAsTemplateDetail items-center justify-center p-4 text-neutral/40">
        <span>No data available</span>
      </Col>
    );
  }

  return (
    <Col className="@FileSetAsTemplateDetail gap-3" gap3>
      <Col className="rounded-md border border-neutral/10 bg-white p-3" gap2>
        <span className="text-xs font-medium text-neutral/60">
          File Details
        </span>
        <div className="grid grid-cols-2 gap-x-4 gap-y-1">
          <IDField label="ID" value={file.id?.value} />
          <FieldDisplay label="File Name" value={file.fileName} />
          <FieldDisplay
            label="File Size"
            value={formatFileSize(file.fileSize)}
          />
          <FieldDisplay label="MIME Type" value={file.mimeType} />
        </div>
      </Col>

      <Col
        className="rounded-md border border-primary/20 bg-primary/5 p-3"
        gap2
      >
        <span className="text-xs font-medium text-primary/80">
          Template Details
        </span>
        <div className="grid grid-cols-2 gap-x-4 gap-y-1">
          <FieldDisplay label="Template ID" value={event.templateId} />
          <FieldDisplay label="Description" value={event.description} />
          <FieldDisplay label="Set By" value={event.setBy} />
          {setAtStr && (
            <FieldDisplay
              label="Set At"
              value={humanReadableDateTime(setAtStr, { locale: getLocale() })}
            />
          )}
        </div>
      </Col>
    </Col>
  );
};
